import React from 'react';

function TyphoidVaccineForm() {
  return (
    <div>
      <h2>TyphoidVaccineForm</h2>
    </div>
  );
}

export default TyphoidVaccineForm;
